/* global Swiper */
// *******************************************************************************
// 1.0 - Text image slider
// *******************************************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  window.textImageSliderElements = document.querySelectorAll('[data-slider="text-image-slider"]');

  window.textImageSliderOptions = {
    slidesPerView: 1,
    spaceBetween: 12,
    speed: 600,
    autoHeight: true,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  textImageSliderElements.forEach((el) => {
    const parent = el.closest('.text-image-slider');
    const arrowRight = parent.querySelector('.swiper-button-next');
    const arrowLeft = parent.querySelector('.swiper-button-prev');
    const paginationElement = parent.querySelector('.swiper-pagination');

    textImageSliderOptions.pagination.el = paginationElement;
    textImageSliderOptions.navigation.nextEl = arrowRight;
    textImageSliderOptions.navigation.prevEl = arrowLeft;

    const swiper = new Swiper(el, textImageSliderOptions);

    window.addEventListener('load', () => {
      swiper.update();
    });

    const images = el.querySelectorAll('img');
    images.forEach((img) => {
      img.onload = () => {
        swiper.update();
      };
    });
  });
});
